import React from 'react';
import T from 'prop-types';

import { compose } from 'redux';

import { useQuery } from '@apollo/client';
import { connect } from 'react-redux';
import { CenteredLoader } from '@playbookux/playbook-web-core';
import {
  WrapperContainer,
  DisqualifiedContainer,
  Logo,
  BlueStrip,
  DisqualifiedLabel,
} from '../styles';

import { withTranslation } from '../../../../core/i18n';

import { SCREENER_SESSION } from './graphql';
import { CenteredContent } from './styles';

const ScreenerSessionDisqualified = (props) => {
  const {
    phrases, sessionId,
  } = props;

  const {
    data = {},
    loading,
  } = useQuery(SCREENER_SESSION, {
    variables: {
      id: sessionId,
    },
  });

  const { disqualifyRedirectUrl = null } = data?.screenerSession?.tester?.project || {};

  if (disqualifyRedirectUrl) {
    // eslint-disable-next-line no-restricted-globals
    window.open(disqualifyRedirectUrl, '_self');
    return null;
  }

  if (loading || disqualifyRedirectUrl) {
    return (
      <CenteredContent>
        <CenteredLoader />
      </CenteredContent>
    );
  }
  return (
    <WrapperContainer>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />
      <BlueStrip />
      <DisqualifiedContainer>
        <DisqualifiedLabel>{phrases?.you_did_not_qualify_screeners}</DisqualifiedLabel>
      </DisqualifiedContainer>
    </WrapperContainer>
  );
};

ScreenerSessionDisqualified.propTypes = {
  phrases: T.func,
  history: T.shape({
    push: T.func,
  }).isRequired,
  sessionId: T.string.isRequired,
};

ScreenerSessionDisqualified.defaultProps = {
  phrases: {},
};

const mapStateToProps = (props) => ({
  sessionId: props.authentication.sessionId,
});

export default compose(
  connect(mapStateToProps),
  withTranslation,
)(ScreenerSessionDisqualified);
